/**
 * VitaMea – Mega Menu Overlay Controller v3
 *
 * Logica:
 * - Mostra overlay scuro SOLO quando mega menu hover è aperto
 * - Si nasconde IMMEDIATAMENTE se qualsiasi drawer/modal viene aperto
 * - Usa document-level event listener per intercettare qualsiasi apertura
 */
(function () {
  'use strict';

  function initOverlay() {
    var overlay = document.querySelector('.header-section ~ .overlay, .header-section + .overlay');
    if (!overlay) {
      var allOverlays = document.querySelectorAll('.overlay');
      for (var i = 0; i < allOverlays.length; i++) {
        var parent = allOverlays[i].closest('cart-drawer, x-modal, .drawer');
        if (!parent) {
          overlay = allOverlays[i];
          break;
        }
      }
    }
    if (!overlay) return;

    var megaMenuDetails = document.querySelectorAll(
      '.header__menu details[is="details-mega"], .header__menu details[is="details-dropdown"], .header__navigation details[is="details-mega"], .header__navigation details[is="details-dropdown"]'
    );
    if (!megaMenuDetails.length) return;

    var overlayActive = false;

    function showOverlay() {
      overlayActive = true;
      overlay.classList.add('vitamea-overlay-visible');
    }

    function hideOverlay() {
      overlayActive = false;
      overlay.classList.remove('vitamea-overlay-visible');
    }

    function anyMegaMenuOpen() {
      return Array.prototype.some.call(megaMenuDetails, function (d) {
        return d.hasAttribute('open');
      });
    }

    megaMenuDetails.forEach(function (details) {
      var observer = new MutationObserver(function () {
        if (anyMegaMenuOpen()) {
          showOverlay();
        } else {
          hideOverlay();
        }
      });
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
    });

    document.addEventListener('theme:drawer:open', hideOverlay);
    document.addEventListener('theme:modal:open', hideOverlay);
    document.addEventListener('theme:cart:open', hideOverlay);

    var drawerTargets = document.querySelectorAll('cart-drawer, x-modal');
    drawerTargets.forEach(function (el) {
      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'hidden') {
            if (!el.hasAttribute('hidden')) {
              hideOverlay();
            }
          }
        });
      });
      obs.observe(el, { attributes: true, attributeFilter: ['hidden'] });
    });

    var cartButtons = document.querySelectorAll('[aria-controls="CartDrawer"], [data-drawer="CartDrawer"]');
    cartButtons.forEach(function (btn) {
      btn.addEventListener('click', hideOverlay);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header__navigation, .header__menu')) {
        if (!anyMegaMenuOpen()) hideOverlay();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverlay);
  } else {
    initOverlay();
  }
})();
